import React from 'react'
import style from "./index.module.css";
import img_metaLogo from "./metaLogo.jpg";

export default function NotCompatibleScreen() {
    return (
        <div className={style.container}>
            <div className={`${style.dflex} ${style.formContainer}`}>
                <img src={img_metaLogo} alt="meta-logo" />
                <p>
                    The experience works best on desktop devices.
                    {/* Please use desktop browser for experienceing the metaverse. */}
                </p>
            </div>
        </div>
    )
}
